import Krinky from './components/Origin/krinky'

function App() {
    return <Krinky/>;
}

export default App;